import React, { useEffect } from 'react'
import ProductsSection from './components/MainProducts'
import ContactForm from './components/Formsection'
import Footer from './components/Footer'
import NewHome from './components/newHome'
// import MissionVision from './components/MissionVision'
import NewAbout from './components/newAbout'
import NewMission from './components/newMission'
// import SubNavbar from './components/subNavbar'


export default function Homepage() {
    
    useEffect(() => {
        // Scroll to the top when the route changes
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>

            {/* <Navbarsm/> */}

            {/* <Carousalfirst /> */}
            {/* <Carousalsecond/> */}
            {/* <CarouselThird/> */}
            <NewHome />
            <section id='about'>

                {/* <AboutUsSection /> */}
                <NewAbout/>
            </section>
            <NewMission/>
            {/* <MissionVision /> */}
            {/* <VissionCards/> */}
            {/* <VisionMission /> */}


            <ProductsSection />
            {/* <CategoriesSection /> */}

            {/* <ClientsSection /> */}
            {/* <ContactUs /> */}
            <ContactForm />
            <Footer />
        </div>
    )
}
